import React from "react";
import { getBreakPoint, PaddingTopBottom15, useScreenWidth } from "oolib";
import { useFormValidationContext } from "../../../../../../contexts/formValidationContext";
import { EditBlockGenerator } from "../../../../../../utils/blockGenerators";
import { prepareEditConfig } from "../../utils/prepareEditConfig";
import { DefaultFormWrapper } from "../FormConfigsRenderer";

export const EditLayout = ({
  tpl,
  content,
  memo,
  handleOnChange,
  genIndexBar,
}) => {
  const { formValidation, setFormValidation } = useFormValidationContext();
  const screenWidth = useScreenWidth();
  const editConfig = prepareEditConfig(tpl);

  const formContent = (
    <DefaultFormWrapper>
      {editConfig.map((block, i) => (
        <EditBlockGenerator
          key={i}
          memo={memo}
          block={block}
          onChange={handleOnChange}
          content={content}
          Wrapper={PaddingTopBottom15}
          formValidation={formValidation}
          setFormValidation={setFormValidation}
       
        />
      ))}
    </DefaultFormWrapper>
  );

  return !genIndexBar ? (
    formContent
  ) : (
    <div style={{ position: "relative" }}>
      {screenWidth >= getBreakPoint("xl") ? genIndexBar({ formValidation }) : null}
      {formContent}
      {screenWidth < getBreakPoint("xl") ? genIndexBar({ formValidation }) : null}
    </div>
  );
};